import app, { Component } from 'apprun';
import { isValidElement, showSaveStatusMessage , lookup_en, isStringEqual } from '../utils';
import { feeException } from '../api';
import moment from 'moment';

export default class CommonPropertyComponent extends Component {
  dateFmt = 'DD-MMM-YYYY';

  state = { feeExceptions: [] };
  exceptionTypeOptions = lookup_en['FeeExceptionReasonCt'];

  Item = ({ item }) => {
    return (
      <tr
        style={{ display: 'table-row' }}
        onclick={
          !item.locked
            ? (e) => {
              this.run('feeException-edit', item, e);
            }
            : ''
        }>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {this.exceptionTypeOptions.find(e => e.id === item.exceptionType).value}
          </span>
        </td>

        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : ''}
          </span>
        </td>

        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.multiplier}
          </span>
        </td>

        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.cappingAmount}
          </span>
        </td>

        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.monthlyFee}
          </span>
        </td>

        <td>
          <td>
            <i class="control-label glyphicon glyphicon-pencil" />
          </td>
        </td>
      </tr>
    );
  };

  List = ({ state }) => {
    return (
      <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
        <thead>
          <tr>
            <th>Exception Type</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Multiplier</th>
            <th>Capping Amount</th>
            <th>Monthly Fee</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          {state.feeExceptions.map(item => (
            <this.Item item={item} />
          ))}
        </tbody>
      </table>
    );
  };

  FeeExceptionHistory = ({ state }) => {
    return (
      <div>
        <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
          <this.List state={state} />
        </div>
      </div>
    );
  };

  ddlComp = ({ id, optoins, objWithRetAttrib, retAttrib }) => {
    return (
      <div>
        <select id={id} class="form-control" oninput={e => (objWithRetAttrib[retAttrib] = e.target.value)}>
          <option value="-1">[Select]</option>
          {optoins.map(p => (
            <option
              value={p.id}
              selected={isStringEqual(p.id, objWithRetAttrib?.[retAttrib])?'selected':''}>
              {p.value}
            </option>
          ))}
        </select>
        <div id={id + 'ErrMsg'} class="text-danger, row"></div>
      </div>
    );
  };

  FeeExceptionEdit = ({ state }) => {
    return (
      <div style={{ display: state.editingFeeException ? 'disp' : 'none' }}>
        <div class="row" style={{ display: state.newFeeException ? 'disp' : 'none' }}>
          **NEW**
        </div>
        <br />
        <div class="row">
          <label class="col-sm-3">Exception Type</label>
          <div class="col-sm-6">
            <this.ddlComp
              id="exceptionType"
              optoins={lookup_en.FeeExceptionReasonCt}
              objWithRetAttrib={state.feeExceptionUnderEdit}
              retAttrib="exceptionType"
            />
          </div>
        </div>

        <br />
        <div class="row">
          <label class="col-sm-3">Start Date</label>
          <div class="col-sm-6">
            <input id="feeExceptionStartDate" $pikaday size="62" class="form-control" value={state.feeExceptionStartDate} />
            <div id="feeExceptionStartDateErrMsg" class="text-danger, row"></div>
          </div>
        </div>

        <br />
        <div class="row">
          <label class="col-sm-3">End Date</label>
          <div class="col-sm-6">
            <input id="feeExceptionEndDate" $pikaday size="62" class="form-control" value={state.feeExceptionEndDate} />
            <div id="feeExceptionEndDateErrMsg" class="text-danger, row"></div>
          </div>
        </div>
        <br />

        <div class="row">
          <label class="col-sm-3">Fee Multiplier</label>
          <div class="col-sm-6">
            <input id="multiplier" size="20" name="multiplier" class="form-control" value={state.multiplier} />
            <div id="multiplierErrMsg" class="text-danger, row"></div>
          </div>
        </div>
        <br />

        <div class="row">
          <label class="col-sm-3">Capping Amount</label>
          <div class="col-sm-6">
            <input
              id="cappingAmount"
              size="20"
              name="cappingAmount"
              class="form-control"
              value={state.cappingAmount}
            />
            <div id="cappingAmountErrMsg" class="text-danger, row"></div>
          </div>
        </div>
        <br />

        <div class="row">
          <label class="col-sm-3">Monthly Fee</label>
          <div class="col-sm-6">
            <input id="monthlyFee" size="20" name="monthlyFee" class="form-control" value={state.monthlyFee} />
            <div id="monthlyFeeErrMsg" class="text-danger, row"></div>
          </div>
        </div>
        <br />

        <div class="row">
          <div id="feeExceptionReturnedErrMsg" class="text-danger, col-sm-5">
            {state.feeExceptionSaveError}
          </div>
        </div>

        <br />
        <div>
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('feeException-edit-save')}>
            Save
          </a>

          <a
            type="button"
            class="btn btn-primary btn-xs"
            onclick={() => this.run('feeException-edit-delete')}
            style={{
              display: !state.newFeeException ? 'disp' : 'none'
            }}>
            Delete
          </a>

          <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('feeException-edit-cancel')}>
            Cancel
          </a>
        </div>
      </div>
    );
  };

  // prettier-ignore
  view = (state) => {
    //this.log('In view of common-props-date-edit...');
    //this.log(state);
    return (
      <div style={{ width: '550px' }}>
        <this.FeeExceptionHistory state={state} />
        <div>
          <a type="button" class="btn btn-primary btn-xs" onclick={e => this.run('feeException-new', e)}>
            +New
          </a>
        </div>
        <br/>
        <this.FeeExceptionEdit state={state} />
      </div>
    );
  };

  update = {
    refresh: async (state, newState) => {
      //this.log('In refresh of prop fee exception ...');
      const data = await feeException.get(newState.personId);

      state.feeExceptions = data.feeExceptions;
      state.defaultMultiplier = data.multiplier;
      state.defaultCappingAmount = data.cappingAmount;
      state.defaultMonthlyFee = 0.0;

      return { ...state, ...newState };
    },

    'feeException-new': (state, e) => {
      this.run(
        'feeException-edit',
        {
          feeExceptionId: 0,
          multiplier: state.defaultMultiplier,
          cappingAmount: state.defaultCappingAmount,
          monthlyFee: state.defaultMonthlyFee
        },
        e
      );
    },

    'feeException-edit': (state, item) => {
      state.feeExceptionSaveError = null;

      state.feeExceptionStartDate = item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : '';
      state.feeExceptionEndDate = item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : '';

      state.newFeeException = item.feeExceptionId === 0;
      state.editingFeeException = true;

      state.feeExceptionId = item.feeExceptionId;

      state.multiplier = item.multiplier;
      state.cappingAmount = item.cappingAmount;
      state.monthlyFee = item.monthlyFee;

      state.feeExceptionUnderEdit = item;

      return state;
    },

    'feeException-edit-save': async (state) => {
      document.getElementById('exceptionTypeErrMsg').innerHTML = '';
      document.getElementById('feeExceptionStartDateErrMsg').innerHTML = '';
      document.getElementById('feeExceptionEndDateErrMsg').innerHTML = '';

      document.getElementById('multiplierErrMsg').innerHTML = '';
      document.getElementById('cappingAmountErrMsg').innerHTML = '';
      document.getElementById('monthlyFeeErrMsg').innerHTML = '';

      document.getElementById('feeExceptionReturnedErrMsg').innerHTML = '';

      state.feeExceptionSaveError = null;
      const feeExceptionReturnedErrMsgDiv = document.getElementById('feeExceptionReturnedErrMsg') as HTMLDivElement;
      feeExceptionReturnedErrMsgDiv.innerHTML = state.feeExceptionSaveError;

      state.feeExceptionStartDate = (document.getElementById('feeExceptionStartDate') as HTMLInputElement).value.trim();
      state.feeExceptionEndDate = (document.getElementById('feeExceptionEndDate') as HTMLInputElement).value.trim();

      state.multiplier = (document.getElementById('multiplier') as HTMLInputElement).value.trim();
      state.cappingAmount = (document.getElementById('cappingAmount') as HTMLInputElement).value.trim();
      state.monthlyFee = (document.getElementById('monthlyFee') as HTMLInputElement).value.trim();

      //console.log(state);

      let valid = true;

      if (state.feeExceptionUnderEdit.exceptionType === null || state.feeExceptionUnderEdit.exceptionType === '-1') {
        valid = false;
        const errMsg = document.getElementById('exceptionTypeErrMsg') as HTMLDivElement;
        errMsg.innerHTML = '* Please select exception type.';
      }

      if (state.feeExceptionStartDate === '') {
        valid = false;
        const errMsg = document.getElementById('feeExceptionStartDateErrMsg') as HTMLDivElement;
        errMsg.innerHTML = '* Start date cannot be empty.';
      } else {
        valid = valid && isValidElement('feeExceptionStartDate', 'DateStr');
      }

      if (state.feeExceptionEndDate === '') {
        valid = false;
        const errMsg = document.getElementById('feeExceptionEndDateErrMsg') as HTMLDivElement;
        errMsg.innerHTML = '* End date cannot be empty.';
      } else {
        valid = valid && isValidElement('feeExceptionEndDate', 'DateStr');
      }

      if (
        valid &&
        moment(state.feeExceptionStartDate, this.dateFmt) > moment(state.feeExceptionEndDate, this.dateFmt)
      ) {
        valid = false;
        const errMsg = document.getElementById('feeExceptionEndDateErrMsg') as HTMLDivElement;
        errMsg.innerHTML = '* End date cannot be before Start date';
      }

      if (valid) {
        const firstdate = moment(state.feeExceptionStartDate, this.dateFmt)
          .startOf('month')
          .format(this.dateFmt);

        if (!moment(state.feeExceptionStartDate, this.dateFmt).isSame(moment(firstdate, this.dateFmt))) {
          valid = false;
          const errMsg = document.getElementById('feeExceptionStartDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = '* Start date must be the first day of the month.';
        }
      }

      if (valid) {
        const lastdate = moment(state.feeExceptionEndDate, this.dateFmt)
          .endOf('month')
          .format(this.dateFmt);

        if (!moment(state.feeExceptionEndDate, this.dateFmt).isSame(moment(lastdate, this.dateFmt))) {
          valid = false;
          const errMsg = document.getElementById('feeExceptionEndDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = '* End date must be the last day of the month.';
        }
      }

      if (state.multiplier === '') {
        valid = false;
        const errMsg = document.getElementById('multiplierErrMsg') as HTMLDivElement;
        errMsg.innerHTML = '* Multiplier cannot be empty.';
      } else {
        valid = valid && isValidElement('multiplier', 'Number');
      }

      if (state.cappingAmount === '') {
        valid = false;
        const errMsg = document.getElementById('cappingAmountErrMsg') as HTMLDivElement;
        errMsg.innerHTML = '* Capping Amount cannot be empty.';
      } else {
        valid = valid && isValidElement('cappingAmount', 'Number');
      }

      if (state.monthlyFee === '') {
        valid = false;
        const errMsg = document.getElementById('monthlyFeeErrMsg') as HTMLDivElement;
        errMsg.innerHTML = '* Monthly Fee cannot be empty.';
      } else {
        valid = valid && isValidElement('monthlyFee', 'Number');
      }

      if (valid) {
        const exceptionToSave = {
          FeeExceptionId: state.feeExceptionId,
          ExceptionType: state.feeExceptionUnderEdit.exceptionType,
          StartDate: state.feeExceptionStartDate,
          EndDate: state.feeExceptionEndDate,
          Multiplier: state.multiplier,
          CappingAmount: state.cappingAmount,
          MonthlyFee: state.monthlyFee
        };

        let result;
        try {
          result = await feeException.upsertFeeException(state.personId, exceptionToSave);
          if (result.errorCode !== 0) {
            state.feeExceptionSaveError = '* ' + result.errorMessage;
            const feeExceptionReturnedErrMsgDiv1 = document.getElementById(
              'feeExceptionReturnedErrMsg'
            ) as HTMLDivElement;
            feeExceptionReturnedErrMsgDiv1.innerHTML = state.feeExceptionSaveError;
            return;
          }
          showSaveStatusMessage('fee exception');
        } catch (ex) {
          showSaveStatusMessage();
          const errorMsg = await ex.json();

          state.feeExceptionSaveError = '* ' + errorMsg.exceptionMessage;
          const feeExceptionReturnedErrMsgDiv2 = document.getElementById('feeExceptionReturnedErrMsg') as HTMLDivElement;
          feeExceptionReturnedErrMsgDiv2.innerHTML = state.feeExceptionSaveError;
          return;
        }

        if (result) {
          const data = await feeException.get(state.personId);

          state.feeExceptions = data.feeExceptions;
          state.defaultMultiplier = data.multiplier;
          state.defaultCappingAmount = data.cappingAmount;
          state.defaultMonthlyFee = 0.0;

          state.caller.run('refresh', state.personId);
          this.run('feeException-edit-cancel');
        }
      }
    },

    'feeException-edit-delete': async (state) => {
      document.getElementById('exceptionTypeErrMsg').innerHTML = '';
      document.getElementById('feeExceptionStartDateErrMsg').innerHTML = '';
      document.getElementById('feeExceptionEndDateErrMsg').innerHTML = '';

      document.getElementById('multiplierErrMsg').innerHTML = '';
      document.getElementById('cappingAmountErrMsg').innerHTML = '';
      document.getElementById('monthlyFeeErrMsg').innerHTML = '';

      document.getElementById('feeExceptionReturnedErrMsg').innerHTML = '';
      state.feeExceptionSaveError = null;

      const exceptionToDelete = {
        FeeExceptionId: state.feeExceptionId
      };

      let result;
      try {
        result = await feeException.deleteFeeException(state.personId, exceptionToDelete);
        showSaveStatusMessage('fee exception');
      } catch (ex) {
        showSaveStatusMessage();
        const errorMsg = await ex.json();
        state.feeExceptionSaveError = '* ' + errorMsg;
        return state;
      }
      if (result) {
        const data = await feeException.get(state.personId);

        state.feeExceptions = data.feeExceptions;
        state.defaultMultiplier = data.multiplier;
        state.defaultCappingAmount = data.cappingAmount;
        state.defaultMonthlyFee = 0.0;

        state.caller.run('refresh', state.personId);
        this.run('feeException-edit-cancel');
      }
    },

    'feeException-edit-cancel': (state) => {
      state.editingFeeException = false;
      state.feeExceptionUnderEdit = null;
      state.editingContractOptionId = null;

      return state;
    }
  };

  rendered = (state) => {
    return { ...state, editingFeeException:false, feeExceptionStartDate:'', feeExceptionEndDate:'' };
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
